import { compose } from 'redux';
import { HOT_JAR_TAG } from 'b2b-apps/shop/analytics/types/types';
import { withFlyout } from 'b2b-apps/shop/app/hoc/withFlyout';
import { FlyoutCatalog as FlyoutCatalogComponent } from './FlyoutCatalog';

export const FlyoutCatalog = compose(
  withFlyout(HOT_JAR_TAG.assortmentFlyoutOpen),
)(FlyoutCatalogComponent);

export * from './FlyoutCatalog';
